import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_APPOINTMENT_PREFERENCES = gql`
    query OnboardingAppointmentPreferences($candidateUuid: ID!) {
        onboardingAppointmentPreferences(candidateUuid: $candidateUuid) {
            preferredDay
            timeSlot
        }
    }
`;

const useOnboardingAppointmentPreferences = (candidateUuid) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_APPOINTMENT_PREFERENCES, {
        variables: { candidateUuid },
        skip: !candidateUuid,
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingAppointmentPreferences || [],
        loading,
        error,
        refetch,
    };
};

export default useOnboardingAppointmentPreferences;
